import axios from "axios";
import { HeaderOptions } from "../utils/headers";

export const GetUsersByKioskId = async (kioskId) => {
     const data = await axios.get(`${process.env.REACT_APP_BACKEND_API}/api/auth/getUsers/${kioskId}`, {
     })
     return data.data.data
}